// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__TW5LE","list":"styles_list__1b5tz"};